import { fetchEmployeesInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const EmployeeInMarketResearchKeys = {
    all: ['employeeinmarketresearch'] as const,
    lists: () => [...EmployeeInMarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...EmployeeInMarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...EmployeeInMarketResearchKeys.all, 'detail'] as const,
    detail: (params: number) => [...EmployeeInMarketResearchKeys.details(), params] as const,
}

export const useEmployeeInMarketResearchQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchEmployeesInMarketResearch(SK_PESQUISA),
        queryKey: EmployeeInMarketResearchKeys.detail(SK_PESQUISA),
        enabled: Boolean(SK_PESQUISA),
    })
}
